import { ChangeEvent } from "react";

export const handleInputChange = (
  event: ChangeEvent<any> | { target: { name: string; value: any } },
  setState: Function
) => {
  const { name, value } = event.target;
  setState((prevState: any) => ({ ...prevState, [name]: value }));
};
